import {
  cleanPagePath,
  cleanValues,
  setupGoogleAnalytics,
  PARAM_REPLACE_TEXT,
} from './piiScrubber';

export {cleanPagePath, cleanValues, setupGoogleAnalytics, PARAM_REPLACE_TEXT};
export default {cleanPagePath, cleanValues, setupGoogleAnalytics};
